import React from 'react';
import { MainDiv, TableContainer, TableRow, SkeletonCell, Div } from './styles';

const AiLogLoading = () => {
  return (
    <MainDiv>
      <TableContainer>
        {[...Array(6)].map((_, rowIndex) => (
          <TableRow key={rowIndex} className={rowIndex === 0 ? 'background-color' : ''}>
            <Div className={rowIndex === 0 ? 'col-1' : ''}>
              <SkeletonCell className={rowIndex === 0 ? 'col-1' : 'col-1 header'} />
            </Div>
            <Div className={rowIndex === 0 ? 'col-2 border' : 'col-2'}>
              <SkeletonCell className='col-2' />
            </Div>
            <Div className={rowIndex === 0 ? 'col-3' : 'col-3'}>
              <SkeletonCell className='col-3' />
            </Div>
          </TableRow>
        ))}
      </TableContainer>
    </MainDiv>
  );
};

export default AiLogLoading;
